<ng-container *ngIf="!vm?.resolved">
  <div class="hero-container">
    <osn-shared-shimmer-loading [width]="loadingWidth$ | async" [height]="loadingHeight$ | async"></osn-shared-shimmer-loading>
  </div>
</ng-container>
<ng-container *ngIf="vm && vm.resolved && vm.items.length > 0">
  <div
    class="hero-container"
    [@ltrAnimation]="isArabic ? undefined : slideCounter"
    [@rtlAnimation]="isArabic ? slideCounter : undefined"
    (mouseenter)="onHeroContainerMouseEnter()"
    (mouseleave)="onHeroContainerMouseLeave()"
    (swipeleft)="onSwipeLeft()"
    (swiperight)="onSwipeRight()"
  >
    <ng-container *ngIf="!(isMobile$ | async) && !isSingleHeroItem">
      <div (click)="onPrevClick()" class="swipe-btn left">
        <svg-icon key="left" size="sm" class="swipe-icon" data-testid="HomePage.heroSwipeButtonLeft"></svg-icon>
      </div>
      <div (click)="onNextClick()" class="swipe-btn right">
        <svg-icon key="right" size="sm" class="swipe-icon" data-testid="HomePage.heroSwipeButtonRight"></svg-icon>
      </div>
    </ng-container>
    <div *ngIf="vm.title" class="hero-title">
      {{ vm.title }}
    </div>
    <osn-shared-hero-item
      *ngFor="let heroItem of vm.items; index as index; trackBy: trackbyFn"
      [attr.data-testid]="index === 0 ? 'HomePage.firstSharedHeroItem' : 'HomePage.sharedHeroItem'"
      class="hero-item"
      [class.current]="currentIndex === index"
      [class.previous]="prevIndex === index"
      [style.display]="currentIndex === index || (prevIndex === index && transitionInProgress) ? 'block' : 'none'"
      [style.z-index]="currentIndex === index ? 1 : 0"
      [vm]="heroItem"
      [readonlyMode]="vm.readonlyMode"
      (heroItemButtonClick)="onHeroItemButtonClick($event)"
      (heroItemGenreClick)="onHeroItemGenreClick($event)"
    ></osn-shared-hero-item>
    <div class="step-indicator-container justify-content-center align-items-center" *ngIf="!isSingleHeroItem">
      <div
        class="step-indicator"
        (click)="onStepIndicatorClick(index)"
        *ngFor="let heroItem of vm.items; index as index"
        [class.active]="index === currentIndex"
      ></div>
    </div>
  </div>
</ng-container>

<div class="empty-hero-spacer" *ngIf="vm && vm.resolved && vm.items.length === 0"></div>
